import type { JSX } from "react";
import { CommandCopy } from "../molecules/CommandCopy.tsx";
import { LABD_ACCESS_NOTE, LABD_INSTALL_COMMAND, LABD_MARKETPLACE_URL } from "../../lib/labd.ts";

/** Scrolls to the labd section and moves keyboard focus to its heading. */
function scrollToLabd(): void {
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  document.getElementById("labd")?.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
  document.getElementById("labd-title")?.focus({ preventScroll: true });
}

/** labd promo band. Part of the hero grid, so it's visible without scrolling. */
export function LabdBanner(): JSX.Element {
  return (
    <aside className="home-labd-band" aria-labelledby="labd-banner-title">
      <div className="home-labd-band-text">
        <p className="home-labd-kicker">AI tool · free to install</p>
        <h2 id="labd-banner-title">labd, the Dev Labs lab assistant</h2>
        <p>
          Explains the file you're on, the error you're stuck on, and the concept behind the
          fix. In VS Code and in your terminal.
        </p>
        <p className="home-labd-note">{LABD_ACCESS_NOTE}</p>
      </div>
      <div className="home-labd-band-actions">
        <a className="home-labd-primary" href={LABD_MARKETPLACE_URL} target="_blank" rel="noopener">
          Install for VS Code, free ↗
        </a>
        <CommandCopy command={LABD_INSTALL_COMMAND} />
        <button type="button" className="home-labd-more" onClick={scrollToLabd}>
          See what it does ↓
        </button>
      </div>
    </aside>
  );
}
